export const debounce = <T extends (...args: never[]) => void>(
  fn: T,
  wait: number,
) => {
  let timeoutID: ReturnType<typeof setTimeout> | undefined

  return (...args: Parameters<T>): void => {
    if (timeoutID) clearTimeout(timeoutID)
    timeoutID = setTimeout(() => fn(...args), wait)
  }
}

export const debeounced400 = debounce((fn: () => void) => fn(), 400)
